import { instance } from 'utils/axios.utils';
import { GetProjectViewsResponse, RecordViewBody, RecordViewResponse } from 'interfaces/target_view.interface';

const targetView = {
  recordView: (body: RecordViewBody): Promise<RecordViewResponse> => {
    const promise = new Promise<RecordViewResponse>((resolve, reject) => {
      const url = 'target_view/record';
      instance()
        .post(url, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response) {
            reject(error.response?.data?.message);
          } else {
            reject(error);
          }
        });
    });
    return promise;
  },

  getProjectViews: (projectId: string): Promise<GetProjectViewsResponse> => {
    const promise = new Promise<GetProjectViewsResponse>((resolve, reject) => {
      const url = `target_view/project/${projectId}`;
      instance()
        .get(url)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response) {
            reject(error.response?.data?.message);
          } else {
            reject(error);
          }
        });
    });
    return promise;
  },
};

export default targetView;
